<template>
  <header>
    <div class="answer-progress">
      <progress
        class="progress is-primary is-tiny"
        :value="Object.keys(answers).length"
        :max="progressQuestionIds.length"
      />
    </div>
    <b-notification
      v-if="$previewCode"
      type="is-warning"
      aria-close-label="Close notification"
      role="alert"
      class="preview-alert"
    >
      当前为预览页面，答案不被记录
    </b-notification>
  </header>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'AnswerHeader',

  computed: {
    ...mapGetters([
      'progressQuestionIds',
    ]),
    ...mapState([
      'answers',
    ]),
  },
};
</script>

<style lang="scss" src="./answers.scss"></style>
